import React, { FC, useEffect, useState } from "react";
import cn from "classnames";
import styles from "./Item.module.sass";
import { IObject } from "toolkit/steps/stepSix/stepSix.types";
import { Clock } from "./Clock/Clock";
import { useAppDispatch, useAppSelector } from "toolkit/hooks";
import { AddToAttachmentList, ChangeChooseAll, RemoveFromAttachmentList } from "toolkit/steps/stepSix/stepSix.slice";

interface ItemProps {
	object: IObject;
	width?: string;
	repeatable?: boolean;
}

export const Item: FC<ItemProps> = ({ object, width, repeatable = false }) => {
	const {
		formationMode,
		allChecked,
		attachmentList,
		allCheckedGlobal,
		excludedObjects,
		batchesMode,
	} = useAppSelector((state) => state.stepSix);
	const [checkbox, setCheckbox] = useState<boolean>(false);
	const dispatch = useAppDispatch();

	useEffect(() => {
		if (allChecked && attachmentList.includes(object.id)) setCheckbox(true);
		else if (!allChecked && allChecked !== null) setCheckbox(false);
		//eslint-disable-next-line
	}, [allChecked, attachmentList]);

	useEffect(() => {
		if (attachmentList.includes(object.id) || (allCheckedGlobal && !excludedObjects.includes(object.id)))
			setCheckbox(true);
		//eslint-disable-next-line
	}, []);

	const changeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
		dispatch(ChangeChooseAll(null));
		if (e.target.checked) dispatch(AddToAttachmentList(object.id));
		else dispatch(RemoveFromAttachmentList(object.id));
		setCheckbox(e.target.checked);
	};

	// выбрать всё, выход со страницы

	return (
		<div className={cn(styles["item-wrp"], styles[`item-wrp-${width}`])}>
			<label
				htmlFor={`object-${object.id}`}
				className={cn(
					styles.item,
					formationMode && styles.label,
					object.timeToSend ? styles["item-done"] : styles["item-waiting"],
					repeatable && styles["item-repeat"],
				)}>
				<div className={styles["label-wrp"]}>
					{formationMode && (
						<input
							checked={checkbox}
							onChange={changeHandler}
							type="checkbox"
							id={`object-${object.id}`}
							className={styles.checkbox}
						/>
					)}
					<div>
						<span
							className={cn(
								styles["item-code"],
								object.timeToSend && !formationMode && !batchesMode && styles["item-code-padding"],
							)}>
							{object.code}
						</span>
						<div className={styles["item-name-wrp"]}>
							{!formationMode && object.timeToSend && !batchesMode && <Clock object={object} />}
							<span className={styles["item-name"]}>{object.name}</span>
						</div>
					</div>
				</div>
			</label>
		</div>
	);
};
